import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { InputTextModule } from 'primeng/inputtext'
import { DividerModule } from 'primeng/divider'
import { TooltipModule } from 'primeng/tooltip'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { FormsModule } from '@angular/forms'
import { ToastModule } from 'primeng/toast'
import { CardModule } from 'primeng/card'
import { NgModule } from '@angular/core'
import { TagModule } from 'primeng/tag'

import { RiskScorecardConfigDetailComponent } from './components/risk-scorecard-config-detail/risk-scorecard-config-detail.component'
import { RiskScorecardConfigListComponent } from './components/risk-scorecard-config-list/risk-scorecard-config-list.component'
import { ScorecardTierEditorComponent } from './components/scorecard-tier-editor/scorecard-tier-editor.component'
import { ScorecardSimulationComponent } from './components/scorecard-simulation/scorecard-simulation.component'
import { SharedModule } from '@shared/shared.module'

/**
 * Configuración de la calculadora de riesgo (plan v4.2 §7.2, E2): lista de versiones, detalle con el editor, el
 * editor de tramos de 3 umbrales y el simulador contra la versión activa (§10, E4). Módulo propio importado en `app.module`, como `AlgorithmConfigModule` (que no se
 * toca: su `config-tier-editor` es otra cosa).
 */
@NgModule({
  declarations: [RiskScorecardConfigListComponent, RiskScorecardConfigDetailComponent, ScorecardTierEditorComponent, ScorecardSimulationComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ButtonModule,
    CardModule,
    DialogModule,
    ConfirmDialogModule,
    DividerModule,
    InputTextModule,
    InputTextareaModule,
    TagModule,
    ToastModule,
    TooltipModule,
    SharedModule,
  ],
})
export class RiskScorecardConfigModule {}
